<!-- Modal -->
<div class="modal modal-blur fade" id="hesap-kodu-sec-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Muhasebe Hesap Kodu Arama</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="card p-0">
              <div class="card-body border-bottom py-3">
                <div class="d-flex">
                  <div class="mr-auto text-muted">
                    Hesap Kodu:
                    <div class="ml-2 d-inline-block">
                      <div class="input-icon mb-3">
                        <!-- <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="kodAraLoading">
                          <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                        </span> -->
                        <input name="hesapKoduAra" [autocomplete]="true" type="text"
                          class="form-control form-control-sm" placeholder="Kodu yazıp enter'a basın"
                          [(ngModel)]="hesapKoduAra" (keyup.enter)="kodAraInputChange()">
                      </div>
                    </div>
                  </div>

                  <div class="mr-auto text-muted">
                    Hesap Adı:
                    <div class="ml-2 d-inline-block">
                      <div class="input-icon mb-3">
                        <!-- <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="kodAraLoading">
                          <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                        </span> -->
                        <input name="hesapAdiAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                          placeholder="Adı yazıp enter'a basın" [(ngModel)]="hesapAdiAra" (keyup.enter)="kodAraInputChange()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive" *ngIf="hesapPlani">
                <table class="table card-table table-vcenter text-nowrap datatable">
                  <thead>
                    <tr>
                      <th>Hesap Kodu</th>
                      <th>Hesap Adı</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of hesapPlani">
                      <td>{{h.hesapKodu}}</td>
                      <td>{{h.hesapAdi}}</td>
                      <td class="text-right">
                        <div class="btn btn-sm btn-success" (click)="kodSec(h.hesapKodu)">Seç</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->